module.exports = __webpack_public_path__ + "img/sell-info.b6017637.png";